var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',{attrs:{"layout":"app"}},[_c('workspace-layout',[_c('router-view',{key:_vm.currentWorkspaceId})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }